module.exports = __webpack_public_path__ + "static/media/dashboard-upload.960670af.svg";